{
  "clinicalNotes": "Ghi chú lâm sàng",
  "noteType": "Loại ghi chú",
  "author": "Tác giả",
  "dateTime": "Ngày/Giờ",
  "content": "Nội dung",
  "addNote": "Thêm ghi chú",
  "editNote": "Sửa ghi chú",
  "signNote": "Ký ghi chú",
  "signed": "Đã ký",
  "unsigned": "Chưa ký",
  "types": {
    "progressNote": "Ghi chú tiến triển",
    "admissionNote": "Ghi chú nhập viện",
    "dischargeNote": "Ghi chú xuất viện",
    "consultNote": "Ghi chú hội chẩn",
    "procedureNote": "Ghi chú thủ thuật"
  },
  "editor": {
    "newNote": "Ghi chú mới",
    "titlePlaceholder": "Tiêu đề ghi chú…",
    "create": "Tạo",
    "cancel": "Huỷ",
    "cosignFilterLabel": "Chỉ hiện các ghi chú cần tôi đồng ký",
    "emptyNoCosign": "Không có ghi chú nào cần bạn đồng ký",
    "emptyNoNotes": "Chưa có ghi chú nào",
    "emptySelection": "Chọn một ghi chú hoặc tạo mới",
    "emptySelectionHint": "Chọn từ danh sách bên trái hoặc bấm \"+ Ghi chú mới\" để bắt đầu.",
    "unknownAuthor": "Không rõ",
    "needsCosignBadge": "Cần đồng ký",
    "amendmentBanner": "Sửa đổi ghi chú #{{parentId}} — Lý do: {{reason}}",
    "signedBanner": "Đã ký bởi {{name}} vào {{when}} — Ghi chú này chỉ đọc.",
    "signedByFallback": "bác sĩ",
    "saving": "Đang lưu…",
    "autoSaved": "Đã tự động lưu",
    "actions": {
      "saveDraft": "Lưu nháp",
      "signNote": "Ký ghi chú",
      "amend": "Sửa đổi",
      "cosign": "Đồng ký",
      "printLabel": "In ghi chú"
    },
    "copyForward": "Sao chép ghi chú trước",
    "copyForwardHint": "Sao chép ghi chú đã ký ngày {{date}} — xem lại và cập nhật từng dòng",
    "copiedForwardBadge": "Đã sao chép"
  },
  "dialog": {
    "sign": {
      "title": "Ký ghi chú",
      "body": "Bạn chắc chắn muốn ký ghi chú này? Hành động này không thể hoàn tác. Ghi chú sẽ chỉ đọc sau khi ký.",
      "cancel": "Huỷ",
      "confirm": "Xác nhận ký"
    },
    "amend": {
      "title": "Sửa đổi ghi chú",
      "body": "Vui lòng cung cấp lý do cho việc sửa đổi này. Ghi chú sẽ được cập nhật và đánh dấu là đã sửa đổi.",
      "reasonPlaceholder": "Lý do sửa đổi…",
      "cancel": "Huỷ",
      "confirm": "Xác nhận sửa đổi"
    },
    "cosign": {
      "title": "Đồng ký ghi chú",
      "body": "Bạn chắc chắn muốn đồng ký ghi chú này? Xác nhận này nghĩa là bạn đã xem xét và đồng ý với nội dung của ghi chú.",
      "cancel": "Huỷ",
      "confirm": "Xác nhận đồng ký"
    }
  },
  "toast": {
    "created": "Đã tạo ghi chú",
    "createFailed": "Không tạo được ghi chú",
    "titleRequired": "Vui lòng nhập tiêu đề ghi chú",
    "draftSaved": "Đã lưu nháp",
    "signed": "Đã ký ghi chú thành công",
    "signFailed": "Không ký được ghi chú",
    "amended": "Đã sửa đổi ghi chú thành công",
    "amendFailed": "Không sửa đổi được ghi chú",
    "amendReasonRequired": "Vui lòng nhập lý do sửa đổi",
    "cosigned": "Đã đồng ký ghi chú thành công",
    "cosignFailed": "Không đồng ký được ghi chú"
  },
  "status": {
    "draft": "Nháp",
    "unsigned": "Chưa ký",
    "signed": "Đã ký",
    "amended": "Đã sửa đổi",
    "cosigned": "Đã đồng ký",
    "cosignNeeded": "Cần đồng ký",
    "pendingSignature": "Chờ ký",
    "addendum": "Bổ sung",
    "cosignPending": "Chờ đồng ký"
  },
  "worklist": {
    "title": "Danh sách ghi chú chưa ký",
    "backToDashboard": "Bảng điều khiển",
    "filtersHeading": "Bộ lọc",
    "filterAllNoteTypes": "Tất cả loại ghi chú",
    "filterAllStatuses": "Tất cả trạng thái",
    "filterAuthorPlaceholder": "Lọc theo tác giả…",
    "dateFromAria": "Từ ngày",
    "dateToAria": "Đến ngày",
    "columns": {
      "patient": "Bệnh nhân",
      "mrn": "MRN",
      "noteType": "Loại ghi chú",
      "noteTitle": "Tiêu đề",
      "author": "Tác giả",
      "created": "Tạo lúc",
      "status": "Trạng thái",
      "actions": "Hành động"
    },
    "actions": {
      "signSelected": "Ký mục đã chọn ({{count}})",
      "signing": "Đang ký…",
      "open": "Mở",
      "refresh": "Làm mới"
    },
    "loading": "Đang tải ghi chú…",
    "empty": "Không tìm thấy ghi chú chưa ký",
    "loadError": "Tải ghi chú chưa ký thất bại",
    "retry": "Thử lại",
    "toast": {
      "noneSelected": "Chưa chọn ghi chú nào",
      "signed_one": "Đã ký {{count}} ghi chú thành công",
      "signed_other": "Đã ký {{count}} ghi chú thành công",
      "signFailed": "Một số ghi chú không ký được",
      "partiallySigned_one": "Đã ký {{count}} ghi chú, {{failed}} ghi chú không ký được",
      "partiallySigned_other": "Đã ký {{count}} ghi chú, {{failed}} ghi chú không ký được"
    }
  },
  "type": {
    "progress": "Ghi chú tiến triển",
    "historyPhysical": "H&P",
    "admission": "Ghi chú nhập viện",
    "discharge": "Tóm tắt xuất viện",
    "consult": "Hội chẩn",
    "procedure": "Ghi chú thủ thuật",
    "operative": "Ghi chú phẫu thuật",
    "nursing": "Ghi chú điều dưỡng"
  },
  "template": {
    "list": {
      "title": "Mẫu ghi chú",
      "backToDashboard": "Bảng điều khiển",
      "newButton": "Mẫu mới",
      "columns": {
        "name": "Tên",
        "noteType": "Loại ghi chú",
        "specialty": "Chuyên khoa",
        "sections": "Phần",
        "status": "Trạng thái",
        "actions": "Hành động"
      },
      "active": "Đang dùng",
      "inactive": "Ngừng dùng",
      "loading": "Đang tải mẫu…",
      "empty": "Chưa có mẫu nào. Tạo một mẫu để bắt đầu.",
      "previewTitle": "Xem mẫu: {{name}}",
      "emptySection": "(trống)",
      "tooltips": {
        "preview": "Xem trước",
        "edit": "Sửa",
        "activate": "Kích hoạt",
        "deactivate": "Ngừng kích hoạt"
      },
      "toast": {
        "statusUpdated": "Đã cập nhật trạng thái mẫu"
      }
    },
    "form": {
      "editTitle": "Sửa mẫu",
      "createTitle": "Tạo mẫu",
      "fields": {
        "name": "Tên mẫu",
        "noteType": "Loại ghi chú",
        "specialty": "Chuyên khoa",
        "sections": "Phần"
      },
      "required": "*",
      "namePlaceholder": "ví dụ: Ghi chú tiến triển chuẩn",
      "selectNoteType": "Chọn loại…",
      "selectSpecialty": "Chọn chuyên khoa…",
      "addSection": "Thêm phần",
      "sectionNamePlaceholder": "Tên phần (ví dụ: Lý do vào viện)",
      "sectionDefaultPlaceholder": "Nội dung mặc định cho phần này…",
      "cancel": "Huỷ",
      "create": "Tạo mẫu",
      "update": "Cập nhật mẫu",
      "toast": {
        "created": "Đã tạo mẫu",
        "updated": "Đã cập nhật mẫu",
        "saveFailed": "Không lưu được mẫu",
        "nameAndTypeRequired": "Tên và loại ghi chú là bắt buộc",
        "atLeastOneSection": "Phải có ít nhất một phần"
      }
    },
    "specialty": {
      "general": "Tổng quát",
      "internalMedicine": "Nội khoa",
      "surgery": "Ngoại khoa",
      "pediatrics": "Nhi khoa",
      "cardiology": "Tim mạch",
      "neurology": "Thần kinh",
      "orthopedics": "Chấn thương chỉnh hình",
      "emergencyMedicine": "Cấp cứu"
    },
    "scope": {
      "personal": "Cá nhân",
      "group": "Nhóm",
      "global": "Toàn viện"
    },
    "state": {
      "draft": "Nháp",
      "published": "Đã phát hành"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "Đậm",
      "italic": "Nghiêng",
      "list": "Danh sách",
      "templates": "Mẫu / Cụm từ thông minh",
      "saved": "Đã lưu {{time}}",
      "notSaved": "Chưa lưu",
      "charactersLabel": "ký tự",
      "save": "Lưu {{noteType}}",
      "placeholder": "Bắt đầu nhập {{noteType}} của bạn… Dùng \".\" để kích hoạt cụm từ thông minh.",
      "smartPhrases": {
        "patientName": "Tên bệnh nhân",
        "mrn": "Mã bệnh án",
        "dateOfBirth": "Ngày sinh",
        "allergies": "Dị ứng",
        "vitals": "Dấu hiệu sinh tồn",
        "medications": "Thuốc",
        "problemList": "Danh sách vấn đề"
      }
    }
  }
}
